import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import github from "../../Assets/github.webp";
import twitter from "../../Assets/twitter.webp";
import linkedin from "../../Assets/linkedin.webp";
import instagram from "../../Assets/instagram.webp";
import "./Footer.css";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>
            Diseñado y Desarrollado por:
            <span style={{ color: "rgb(0, 255, 0)" }}> EK</span>
          </h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>
            Copyright<span style={{ color: "rgb(0, 255, 0)" }}> ©</span> {year}{" "}
            <span style={{ color: "rgb(0, 255, 0)" }}> EK</span>
          </h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li key="git" className="social-icons">
              <a
                className="footer-a"
                href="https://github.com/ekisler"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                }}
              >
                <img src={github} alt="GitHub" width="25" height="25" />
              </a>
            </li>
            <li key="twitter" className="social-icons">
              <a
                className="footer-a"
                href="https://twitter.com/ekracing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitter} alt="Twitter" width="25" height="25" />
              </a>
            </li>
            <li key="linkedin" className="social-icons">
              <a
                className="footer-a"
                href="https://www.linkedin.com/in/emisael-kisler-fullstack/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="Linkedin" width="25" height="25" />
              </a>
            </li>
            <li className="social-icons">
              <a
                className="footer-a"
                href="https://www.instagram.com/kisler_tecnologia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img key="insta" src={instagram} alt="Instagram" width="25" height="25" />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
